module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For the first time in twenty years, there was no feast in Sleeth village to celebrate the New Year’s Moon. It was too cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As late as March, heavy snow fell over Sleeth and Chingura, and blocked the mountain passes. At last the thaw came. Ice melted in the Estre River. Snow melted from the spruce boughs. Birds returned from their winter homes in Nakase and Issho, and began to forage, leaving tiny sparse tracks like writing on the near-translucent snow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In late March, when the road between Sleeth and the meadow grew passable, Wolf and Thea went to the village. Wolf hauled the large sled, piled with skins to be sold at the market, and Thea pulled the smaller one, which held four large wool blankets. Three of them would go to Ferrell, to be sold. One was a gift for her mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was slow going; the snow was still high in spots. In the village, they separated. Thea went to her mother’s house. Wolf pulled the big sled as far as the smithy. Ono was bent over some metal, hammering at it, while Corwin held it steady with the tongs. The boy had put muscle on over the winter. Ono looked unchanged. He laid the hammer down.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What brings you into town?” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ve skins to sell,” Wolf said. “Thea wanted to see her mother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She’s all right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She’s fine. We’re both fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They ate that evening at Serret’s house, which was filled with the people who lived there: Serret, her youngest daughter, Martia; her mother, Aea; Felicia and Merrit her husband, and their son, Kevin, born at end of summer. Merrit brought him from the cradle and paraded him boisterously around the room for everyone to admire, as if he were a prize pig. Kevin was passive and placid and slept through the fuss.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After the meal, they crossed the market square to the Red Oak, where Serret made sure that Egain the innkeeper served the best red ale. People moved in and out, stopping to greet Wolf and Thea and say the same things:"), _c('i', [_vm._v(" Good to see you, long winter, late thaw, you look well, strange what’s happening in the north, what news do you hear from the castle, long winter.")]), _vm._v(" After months of solitude and silence, a big room filled with voices and so many faces was a little hard on the nerves. Wolf found it easier to deal with than Thea did. He drained his cup, and pressed Thea’s thigh under the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the other side of the room, a group of five men and one tired-looking woman sat sullenly. The men were drinking; the woman was filling their glasses. One of them, a brawny, bearded man with a scar down his face and gold rings winking on his fingers, seemed to do most of the talking.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The look of them made Wolf uneasy. When Egain stopped by the table to ask if they wanted more ale, Wolf inquired softly, “The men at that table near the door: who are they?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The weasely-looking youth is Tuar; he’s the son of Bryony and Nirrin Maw. Nirrin died four years ago, but Bryony is chief laundress at the Keep. The big one calls himself Rand. He’s from someplace in Nakase. The woman’s Luvia; she lives with Tuar. They have a little girl. Tuar does bits of metalwork, the kind of mending Ono hates to do. He’s not bad at it; he’s mended some of my pots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And Rand—what’s his trade?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Egain pulled a face. “Mischief and mayhem, likely. He claims to be a trapper, but I’ve never seen him with pelts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The scar-faced man rose, and at his barked command the others drained their glasses and followed him. Tuar and Luvia were last out the door. Merrit fed his son a taste of ale. The babe gurgled happily, and then began to hiccup.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Felicia whisked the boy from his arms. “Enough! It’s mother’s milk he needs, not ale. To bed he goes, now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf rose, drawing Thea with him. “We’ll come with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The night was cold and dry, with no threat of snow. A quarter-moon dipped in and out of the scudding clouds. They crossed the square to Serret’s house. Felicia sang softly to Kevin. Merrit lagged behind. Suddenly a stocky figure in trapper’s furs staggered toward them, almost falling into Thea. She cried out in surprise. Wolf stepped swiftly in front of her. He glimpsed a dark knotted face, anguished dark eyes. The man staggered into the wall of a shed, slid down, and lay flat on his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merrit had come quickly up to them at Thea’s cry.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf said, “Who is he?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s Chary. He’s a trapper from Ashavik.” They stood looking down at the man. “He came out of the ice this winter, and stayed.” Merrit did not lower his voice. The man on the ground seemed not to hear it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Felicia said, “Am I walking by myself?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They caught up with her. Thea said, “Is he drunk? He didn’t smell drunk.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No,” Merrit said, “he’s mad. He saw something on the ice, who knows what, and now he won’t go back, and he can’t sleep.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What did he see?” Wolf asked. An owl called from a rooftop. Felicia crooned to the baby, who had stopped hiccuping.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merrit said uneasily, “Oh, it’s nonsense. A tale.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Tell us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He claims that he and his friend were trapping, when a huge beast with fangs and claws and red eyes sprang on them from a rock. It killed his friend. He beat it away with a brand, but when he tried to stab it, his knife broke. He tried to bring his friend’s body back, but the sled stuck in the ice. When he got back to Ashavik, he found the village burned, and his family gone. He hunted for them but could not find them.” There was a question in Merrit’s voice, and he looked at Wolf as if Wolf knew the answer to it, though he had not voiced it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf said, “That’s an evil story.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They stayed three days in the village. They slept at Serret’s, sharing the sleeping room with Serret and Aea and Martia. Thea went to the temple and visited with Felicia. Wolf bargained in the market, trading furs for supplies. When he could, Wolf spent his time with Ono, even taking Corwin’s place at the forge. The third night, the clouds blew wholly away, bringing a night brilliant with stars and a waxing moon. It grew very cold. Under the quilts that night, Thea whispered, “Husband, let’s go home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The next night, as they lay leg to leg in their own bed, with only night sounds about them, she told him she was pregnant. “Sirany says it’s a boy,” she said into the darkness. “A sturdy little wolf cub.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf laid a palm on her smooth, rounded belly, trying to feel the difference. “When?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“October.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The delayed spring came with a rush. All the snow melted in three days, leaving the ground soggy. Fireweed and rhubarb shot first through the earth. The birds returned in an explosion of song, hanging off the birches and alden trees and quarreling over choice nest sites in the spruce. The river rose, and the fish began to crowd it, so that a net thrust into rushing water filled itself. Wolf turned the soil in back of the meadow for a garden. One afternoon he smelled smoke. Following his nose north, to the small meadow above his own, he found a makeshift, ramshackle hut. Near it, a shaggy-coated dun mule ate meadow grass.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tuar the tinker sat outside the hut beside a coal-filled brazier. A drying rack next to the house held clothes, and a blanket. Some of the clothes were child-sized. “Hoy,” Wolf called.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tuar jerked his head up, and stood, peering suspiciously. He came quickly toward his visitor, leaving a glint of metal in the dirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My name is Wolf. My wife and I live in the meadow below you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What do you want?” The hut door opened. A woman, the same tired-looking woman Wolf had seen at the inn, looked out. “Get inside,” the tinker snarled at her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf said, “I smelled your smoke. I came to see who it was.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, now you see,” the young man said sullenly. He went back to his place in the dirt, and hunched over the brazier.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf returned to his own house to tell Thea about their neighbors. “That poor girl,” Thea said thoughtfully. “Did you see aught of the child?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Clothes on a line.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I knew Tuar as a child. He was a pinched-faced little boy. Always whining.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf said, “I can’t say I like them being so close.” But except for the smoke, Tuar and Luvia and their daughter might as well have been invisible. Occasionally Wolf saw other men, one or two, or three, striding toward the upper meadow, and once he recognized Rand. He never saw Tuar with bow or snare or net.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He said to Thea, “I wonder what they’re eating.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t know,” she said, pushing the hair off her face. “I know what we’re eating. Would you bring me some onions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As summer moved toward autumn, Wolf left the meadow to build. Half a dozen people needed such work. Thea was seven months on; her back hurt. He made certain that she had sufficient wood, and that the well pulley was well-greased. She laughed at him and told him not to be a fool, she was fine. He built a storage shed for Ferrell, and new shelves for the wine cellar at the Red Oak. Egain was unhappy; someone had been stealing from his guests. “Most of it is small stuff, coins and trinkets, but one man lost a Chuyo dagger with a small ruby in the hilt,"), _c('i', [_vm._v(" he")]), _vm._v(" claims. If word gets around I have a thief, no one will rent my rooms!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When Wolf next went home, he found Felicia, the baby Kevin, and Martia in possession of the sleeping room. They giggled and fussed, and made it clear there was no place for him upstairs. He slept downstairs, rolled in a blanket. In the night he would wake, missing Thea’s steady breathing beside him, and look at the ceiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A month or so before the baby was to be born, Thea ceased speaking to him. Her beautiful hair grew straggly and her face grew almost gaunt, though her belly was huge. She would barely look at him. “A mood. It will pass. Leave her alone,” Felicia said, but it frightened him. He tried to talk to her, and she turned from him. He brought her toys, a cradle which he had carved for their son, and she would not look at them, or him. He shouted at her, once, in the garden, and Felicia came storming from the house and told him to get out, that he was doing her no good.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He went fishing, but the Estre trout hid from him. He went hunting, and brought back a fat badger. He built a fire in the meadow and laid the beast on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Felicia came from the house. “Thea says the smell makes her sick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He said, “Let her tell me herself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She glared at him from the other side of the fire, hands on her hips. In the warm dusk she looked like Thea. “This happens. You have to be patient. It will end when the baby is born.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My wife will not talk to me, and you tell me to be patient.” He turned the badger with a stick. The fat dripped from the hide and made flame. “Tell me what is happening.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The shifting smoke blew her way. She came and stood next to him. “She is frightened.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of having a baby?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of having"), _c('i', [_vm._v(" your")]), _vm._v(" baby.” Felicia looked obliquely at him. “She told us. Mother, and I. Not Merrit. She told us that you are changeling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What do you think?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With some asperity, she said, “What am I supposed to think? No one in our family married a wolf before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s common, in"), _c('i', [_vm._v(" my")]), _vm._v(" family.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had meant it as a jest, but Felicia responded with anger, “You are not from this country, you don’t know—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then, in the Goddess’s name, tell me what I don’t know!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She did not want to tell him. She hunched her body against the words.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“When Dragon, the lord Karadur, was born, they say he came from his mother not a human baby, but a dragon, with claws and teeth. His mother died, and his womb-brother, Tenjiro, was torn, and"), _c('i', [_vm._v(" he")]), _vm._v(" nearly died. Thea is afraid that your baby will come from her a wolf, with teeth and claws.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Imarru’s balls. Why didn’t you tell me?” Wolf tossed the stick away and went into the house. He thundered into the bedroom. Thea was in bed, on her side. Her face was sunken. Martia hissed at him like a cat. “Get out,” he said. She scurried away. Wolf knelt by the bed. Thea turned her face to the wall. “Dear heart,” he said, “love, listen to me. My mother birthed six children, four changelings, and every one came from her womb pink and butter-soft and human. My little changeling sister Calli, twelve years younger than I, I saw her ten minutes after the birth. She was born human as you and I, and she squalled just like Kevin. Our son will be pink and fat and toothless as he should be. I promise you, Thea, I swear it.” Holding her against him, Wolf stroked her hair, saying it again. Thea said nothing, but she let him hold her, and did not pull away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That night, after they had all gone to sleep, she came slowly down from the sleeping room, and sat beside him in the darkness, her shoulder against his. “What name do you want him to bear?” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Anything you like. I don’t care.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I want to call him Shem.” It meant "), _c('i', [_vm._v("fearless.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Three days later Felicia sent Martia to Sleeth. The next night Rain, accompanied by Sirany the priestess, appeared at the house.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Go away,” Rain said. She patted his shoulder. “Go to the village. Don’t worry, between us we have birthed a hundred babies. Thea is strong and young. Go away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He did not want to go to the village, to sit with the men at the Red Oak. He went into the mountains. Snow made a light white dust across the hills. He climbed in the rocks above the Keep, staying well out of sight of sentries, who would raise the alarm if they saw a wolf so close to the castle. He hunted white grouse and rabbits. He slept in a cave which had been some bear’s den.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stayed wolf for three days. The evening of the third day he went home. Sirany and Rain were gone; Felicia was sleeping downstairs. The sleeping room smelled of milk. Thea drowsed in a nest of blankets. She turned a corner of the blanket to show him a pink flat face, tiny petaled hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His son’s head seemed very wrinkled, and much too big. It was covered with fine dark hair. “Was it bad?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not so bad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He kissed her eyelids, and touched the baby’s cheek with one finger, marveling at the delicacy and softness of the flesh. Somehow they had made this marvel, his son. His own hand seemed huge, grotesque, hard as horn.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Winter roared in. Snow flung itself at the mountains, blocking the roads. Wolf stayed home. There was work to be done: mending snares and nets, carving fish hooks. They had meat and fish on the rack, potatoes and apples in the cellar. They had wood. The snow brought silence, except when the wind blew, or the baby cried.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“His lungs are like Ono’s bellows,” Thea said, walking up and down, jiggling a red-faced infant in her arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After February’s dark moon, new snow ceased to fall. The old snow crust froze hard. Wolf took Shem outside. Thea had bundled the infant securely; he was rigid as a bolster, and twice his true size. He watched everything: the sky, the snow, the chimney-smoke. His wide gaze was intimate and intense.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At the height of the freeze, two men drove a mule-pulled wagon into the meadow. One was young: he looked as if he had just left the farm. The older man had the confident step and ease of a professional soldier.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Dragon sent us,” he said. “Do you need anything? We have meat, wood, flour.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We could use some flour,” Wolf said. Thea had warned that they had little flour left, and that soon there would be no bread. The younger man shouldered two sacks into the pantry. “Would you like ale?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We would indeed,” said the older man. His boots were stiff with mud. “But we can’t stop, if we are to reach the Keep before dark. I’ve heard of you: you’re Wolf the carpenter, who married the weaver. My wife has one of her blankets. I’m Marek Gavrinson. This useless sprout is Toby.” The young soldier grinned. Marek clucked at Shem. “He’s a big one. How old is he?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Three and a half months,” Wolf said. “He’s not that big, he’s just well-wrapped.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Ah. Hello, youngling. Do you like the world?” Marek bent over Shem. The baby gurgled, and reached exploring fingers towards his square black beard. “I have two of these, older. They live at the Keep with their mother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf said, “Do you know about the folk in the meadow above us? There are three of them: the tinker, his wife, and their child.” He felt derelict that he had not visited them: he had no good opinion of Tuar’s hunting skills.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Marek said, “We’ll look in on them. Farewell, youngling. I must go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Two weeks later, at sunset, on his way home from the river with a string of new-caught fish, Wolf smelled smoke. The small hairs lifted on his neck. He sniffed, letting his keener wolf sense work. The strong smell was blowing from the northwest, from the meadow where Tuar and his family had their hut. He ran home, and by the time he got there he could see it, a column of dark smoke rising above the trees. He handed Thea the fish. “It’s the tinker’s house, I think. Pray he hasn’t set the wood on fire. I’m going up there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She touched his face with her hand, like a kiss. “Go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Under the trees, he changed. In wolf form he raced through the trees and along the snow-crusted ground to the small meadow. Under the flat black shadows of the spruce boughs he regained his human form and walked into the clearing. The tinker’s hut was a bonfire burning into the sunset. It was ringed with Dragon Keep’s soldiers. They held Tuar and four other men, one of them Rand. Luvia crouched nearby, a little girl in her arms. The child, terrified by it all, sobbed helplessly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Next to Luvia lay a heap of blankets, pots, clothing, a fishing net, and a smaller pile of shiny objects: rings, pins, a scabbard with gold fittings, a dagger with a red jewel in its hilt. A fair-haired man in a black cloak was standing in front of the hut, head thrown back, watching it burn. The fire gleamed redly on his skin. He wore a long sword across his back, cavalry-style. His face was youthful, but merciless, hard, like steel that can take a blow, and bend, and never crack: a warrior’s face. His hands, despite the cold, were bare.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf moved quietly closer. The man in black said, “Tuar Maw, you are a fool. You were a tinker. Now you are a thief. You know the penalty for thievery in my domains.” His voice was very deep. “You will be taken to my castle, and chained by your wrists to the wall.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Luvia struggled to her feet. Her clothes were threadbare, and her feet were wrapped in rags, as were the child’s. “No. It’s winter. He’ll die.” She stepped forward. “My lord, I beg you. He thought to sell the things he took, to buy food for us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man in black glanced at her. Wolf thought he saw a softness in the ruthless gaze. “Do you plead for him? He beats you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She said, “He is my child’s father. He is not evil, lord, only weak, and easily led. He listened to that man’s talk—” She pointed at Rand. The big man cursed, calling her whore and bitch. One of the soldiers holding him struck him in the face. He thrashed, almost breaking free of their grip.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I see.” The man in black frowned. “Very well. I will spare his life.” Tuar’s head lifted. “But punishment there must be. Tuar Maw! Which arm will you lose?” The color went from Tuar’s face. “Choose, or I choose for you.” But Tuar could not speak. The man in black drew his sword. It glowed red, like fire. “The left. Stretch him out.” Four men wrestled the tinker down. One of them, Wolf saw, was Marek. A soldier tied a rope to Tuar’s left wrist, and pulled it taut. Luvia covered her child’s eyes and averted her head. The sword swept down, and sliced cleanly through the arm at the elbow. The man in black held the blade against the cut limb. Tuar screamed and slumped onto the snow. There was a stink of burnt flesh.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man knelt, cleansed the sword in snow, and wiped it with a cloth. Rising, he said softly to Luvia, “If you come to the castle, you can have food, and a bed. You need not stay with him.” But she shuddered, courage spent, and clutched the little girl tight, and did not answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Suddenly he looked up, directly at Wolf..."), _c('i', [_vm._v(" The snow was on fire. There was blue flame all around him, sweeping toward the trees, he was helpless, trapped, he could not escape ...")]), _vm._v(" Then there were soldiers on either side of him, holding him still, and the tip of the sword was inches from his throat. He could not look away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Dragon.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My lord,” Wolf said, in a whisper.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A deep voice said thoughtfully, “Who are you to call me "), _c('i', [_vm._v("lord")]), _vm._v("? I never took your oath.” The bright hot gaze was like a vise on his mind. Wolf could not have moved had he wanted to.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He said, throat tight, “My lord, I am Illemar Dahranni, called Wolf. I came from Ujo. I served the Lemininkai for nine years. Kalni Leminin released me from his service two years ago. I live in the meadow below this one with my wife, Thea the weaver.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What are you doing here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I thought the hut was burning,” Wolf said simply. “I came to help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The raking blue stare broke the sweat out on Wolf’s face. “Release him,” Karadur said. He sheathed his sword. The hands clamped on Wolf’s arms opened. “Bring"), _c('i', [_vm._v(" them")]), _vm._v(".” He turned, a shadow moving over snow. The soldiers dragged the four men in his wake.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When they were well gone, Wolf went forward. Tuar was moaning, but no blood seeped from the stump: Karadur’s sword had seared it cleanly as a physician’s knife. Luvia looked mutely at Wolf. Her eyes were hollow with shock. She was younger than he had thought; he guessed her to be little more than twenty, and his heart wrung with pity for her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Come to my house,” he said gently. “All of you. You may sleep there tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She shook her head. “He would not like that.” She meant, he realized, Tuar.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You and the child need shelter. It will be dark soon.” She was stubborn with grief. “We stay with him.” He tried to persuade her otherwise, but she refused to move. The child hid its head in her lap.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The next day, Wolf wrote a thoughtful letter to Hawk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("I have met the Dragon of Chingura. We met by accident; he nearly put a sword through my throat. He has hair like the sun and eyes like blue fire, and a grip, so I’m told, that can crack stone. He deals harsh justice. But he is Dragon; I touched his mind, and I am as certain of it as I am of my own nature, or Bear’s, or yours.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A month later, visiting Sleeth, he told Ono what he had seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Aye, I heard about that. Kojiro the Black would have had them all stripped naked and chained on the castle wall for the mountain crows to pick,” the smith said calmly. “But I saw that woman a few days ago, I think it was the same one, at the Red Oak. When are you bringing Thea and the boy to visit us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wolf inquired at the Red Oak. Egain said,"), _c('b'), _vm._v("“I’ve got her scrubbing pots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And Tuar?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He’s working in my stable. He’s not bad with horses, and they don’t care what his arm looks like.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s kind of you, considering.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What mischief can a one-handed groom do? Besides, I know his mother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you know what happened to Rand, and the others?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The lord did as his father would have done: he put them on the walls. They died.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a far, cold place, in a cage made of ice, a naked man lay shivering. A soft, malevolent voice spoke to him; it seemed to come from everywhere: the air, the ice, his mind; it was inescapable as the cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“..."), _c('i', [_vm._v(" You can never leave,”")]), _vm._v(" it said. “You"), _c('i', [_vm._v(" believe you can. You imagine that you are free, free of snow and ice, free of torment, free of nightmare..")]), _vm._v(".” The voice laughed, like ice melting, and cold sweat sluiced down the trembling man’s sides.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("You are not free, traitor. You are in a cage. Your skin sticks to the bars. Your flesh rips each time you move. You freeze, and you beg, and no one comes to open the door. You cannot get out. You will never get out. The ice runs in your veins, in your heart.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("You will never be free. You will never be warm...")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-833eb2b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/OPS/section7.vue
// module id = 93
// module chunks = 0